import { useState, useEffect  } from 'react'
import {SlottedTimeValue} from "../SlottedTimeValue";

const AccreditationInfo = props => {

  //console.log(props)
  const {
    value,
    agencyId,
    scheduledTypesArgs
  } = props



  const productId = tangibleFields.render({
    type: 'text',
    name: 'product_identifier',
    value: value.product_identifier,
    label: 'Product ID',
    description: 'Product ID for reporting to agency',
    min: 0
  })

  return (
    <>
      <div className="tgbl-accreditation-product-id tgbl-field-block">
        { productId }
      </div>
      {/*
      <div className="tgbl-accreditation-fields tgbl-field-block">
        {
          accreditationFields.length > 0 ?
          <FieldInstances
            fieldValues={value.agency_fields}
            fieldDefs={accreditationFields} /> :
          emptyMessage()
        }

      </div>
      */}
      <div className="tgbl-issuance-scheduling-criteria-block tgbl-field-block">
        <div className="tf-issuance-schedules tgbl_accreditation_issuance">
          <div className="tf-pseudo-label">Issuance Scheduling Criteria</div>
          <div className="tf-pseudo-description">Set the terms within which an accreditation can or can't be earned.</div>
        </div>
        <SlottedTimeValue {...{
          name: 'issuance_schedule',
          title: 'Issuance Scheduling Criteria',
          slots: value.issuance_schedule ?? [],
          slotValueFieldDefinitions: [{
            type: 'select', name: 'can_earn', label: 'Earning', choices: scheduledTypesArgs.earnings
          }, {
            type: 'number', name: 'count', label: 'Amount', placeholder: 'Unlimited'
          }],
          scheduledTypesArgs
        }}
        ></SlottedTimeValue>
      </div>
    </>
  )
}

export { AccreditationInfo }
